import { Badge, Flex } from '@radix-ui/themes'
import { badgeColors } from '@/shared/constants/constants'
import { TrackManagerCredentialsIndexCredential } from '@/types/track_manager_credentials_index'
import CredentialReviewForm from '@/shared/track_manager/CredentialReviewForm'
import ExpandableCards from '@/shared/manager/ExpandableCards'

interface Props {
  credentials: TrackManagerCredentialsIndexCredential[]
  /** Arriving from an application under review — open straight onto that credential. */
  focusCredentialId?: number | null
}

/** The mobile credentials queue. */
export default function CredentialsCards({ credentials, focusCredentialId }: Props) {
  return (
    <ExpandableCards
      items={credentials}
      getKey={(credential) => credential.id}
      initialOpenKey={focusCredentialId ?? null}
      emptyMessage="No credentials here."
      renderSummary={(credential) => (
        <Flex direction="column" gap="1">
          <p className="truncate text-[15px] font-bold leading-tight">{credential.email}</p>
          <span className="truncate text-sm text-gray11">
            {credential.form_title} · {credential.track_name}
          </span>
          <Flex gap="2" mt="1" wrap="wrap">
            <Badge
              variant="soft"
              color={badgeColors[credential.status]}
              style={{ textTransform: 'capitalize' }}
            >
              {credential.status}
            </Badge>
            {credential.expired && (
              <Badge variant="soft" color="crimson">
                Expired
              </Badge>
            )}
          </Flex>
        </Flex>
      )}
      renderDetail={(credential) => <CredentialReviewForm credential={credential} compact />}
    />
  )
}
